import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="mobileheader">
            <p class="logo">
                <a ng-if="vm.$state.params.company" ui-sref="unauthorized.login()" ng-include="vm.getPath('logo.svg')"></a>
                <a ng-if="!vm.$state.params.company" ui-sref="root()" ng-include="vm.getPath('logo.svg')"></a>
            </p>
        </div>
        <div class="header">
            <div class="row1">
                <div class="col00">
                    <p class="logo">
                        <a ng-if="vm.$state.params.company" ui-sref="unauthorized.login()" ng-include="vm.getPath('logo02.svg')"></a>
                        <a ng-if="!vm.$state.params.company" ui-sref="root()" ng-include="vm.getPath('logo02.svg')"></a>
                    </p>
                </div>
            </div>
        </div>
    `
})
export default class {
    constructor ($, $state, CompanyResource) {
        this.$state = $state;
        this.$ = $;
        this.CompanyResource = CompanyResource;
    }

    $onInit () {
        if (this.$state.params.company) {
            this.CompanyResource.verifySlug(null, { slug: this.$state.params.company }).$promise.then((company) => {
                this.skin = `${SEED_CORE.ENV.SKIN}`;
                if (company.skin) {
                    this.skin = company.skin;
                }
            });
        }
        else {
            this.skin = `${SEED_CORE.ENV.SKIN}`;
        }
    }

    getPath (file) {
        return this.skin ? `assets/css/${this.skin}/${file}?v=${SEED_CORE.REVISION}` : '';
    }
}



// WEBPACK FOOTER //
// ./src/app/components/header/public/index.js